import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Input/InputSearch.css'

{/*
<InputSearch
    type={'diagnostic' | 'customer' | 'payment'}
    theme={'light' | 'dark'}
    ref={}
    data={}
    search={} setSearch={}
    results={} setResults={}
    placeholder={""}
    icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
    onPressEnter={() => {}}
/>
--inputTextLight: #ffffff;
--inputTextLightText: #49574b;
--inputTextDark: #eef5ef;
--inputTextDarkText: #49574b;
--inputTextSuccess: #435e48;
--inputTextError: #BB4040;
*/}

const InputSearch = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        inputSearchRef: inputSearchRef
    }))

    const inputSearchRef = useRef(null)

    function onChange(search) {

        if (props.type === 'diagnostic') {
            searchDiagnostic(search)
        } else if (props.type === 'customer') {
            searchCustomer(search)
        } else if (props.type === 'payment') {
            searchPayment(search)
        }


    }

    function searchDiagnostic(search) {

        var searchFormat = search.toLowerCase()
        var searchDisplay = search.toLowerCase().split(' ').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join(' ')
        searchDisplay = searchDisplay.split('-').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join('-')
        searchDisplay = searchDisplay.split('\'').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join('\'')
        props.setSearch(searchDisplay)
        if (searchFormat.length > 0) {
            const searchTerms = searchFormat.split(' ').filter(item => item.length > 0)
            let resultsFormat = props.data
            searchTerms.map((item) => {
                resultsFormat = resultsFormat.filter((itemDiagnostic) => {
                    return (
                        itemDiagnostic.status.toLowerCase().includes(item) ||
                        itemDiagnostic.createdAt.toLowerCase().includes(item) ||
                        itemDiagnostic.type.toLowerCase().includes(item) ||
                        itemDiagnostic.customer.firstname.toLowerCase().includes(item) ||
                        itemDiagnostic.customer.lastname.toLowerCase().includes(item) ||
                        itemDiagnostic.customer.email.toLowerCase().includes(item) ||
                        itemDiagnostic.customer.phone.toLowerCase().replace(/\s/g, '').includes(item) ||
                        itemDiagnostic.customer.addressCity.toLowerCase().includes(item) ||
                        itemDiagnostic.customer.addressZipcode.toLowerCase().includes(item)
                    )
                })
                return item
            })
            props.setResults(resultsFormat)
        } else {
            props.setResults(props.data)
        }

    }

    function searchCustomer(search) {

        var searchFormat = search.toLowerCase()
        var searchDisplay = search.toLowerCase().split(' ').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join(' ')
        searchDisplay = searchDisplay.split('-').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join('-')
        searchDisplay = searchDisplay.split('\'').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join('\'')
        props.setSearch(searchDisplay)
        if (searchFormat.length > 0) {
            const searchTerms = searchFormat.split(' ').filter(item => item.length > 0)
            let resultsFormat = props.data
            searchTerms.map((item) => {
                resultsFormat = resultsFormat.filter((itemCustomer) => {
                    return (
                        itemCustomer.createdAt.toLowerCase().includes(item) ||
                        itemCustomer.firstname.toLowerCase().includes(item) ||
                        itemCustomer.lastname.toLowerCase().includes(item) ||
                        itemCustomer.email.toLowerCase().includes(item) ||
                        itemCustomer.phone.toLowerCase().replace(/\s/g, '').includes(item) ||
                        itemCustomer.addressCity.toLowerCase().includes(item) ||
                        itemCustomer.addressZipcode.toLowerCase().includes(item)
                    )
                })
                return item
            })
            props.setResults(resultsFormat)
        } else {
            props.setResults(props.data)
        }

    }

    function searchPayment(search) {

        var searchFormat = search.toLowerCase()
        var searchDisplay = search.toLowerCase().split(' ').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join(' ')
        searchDisplay = searchDisplay.split('-').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join('-')
        searchDisplay = searchDisplay.split('\'').map((item) => item.charAt(0).toUpperCase() + item.substring(1)).join('\'')
        props.setSearch(searchDisplay)
        if (searchFormat.length > 0) {
            const searchTerms = searchFormat.split(' ').filter(item => item.length > 0)
            let resultsFormat = props.data
            searchTerms.map((item) => {
                resultsFormat = resultsFormat.filter((itemPayment) => {
                    return (
                        itemPayment.status.toLowerCase().includes(item) ||
                        itemPayment.createdAt.toLowerCase().includes(item) ||
                        itemPayment.amount.toLowerCase().replace(/\s/g, '').includes(item) ||
                        itemPayment.customer.firstname.toLowerCase().includes(item) ||
                        itemPayment.customer.lastname.toLowerCase().includes(item) ||
                        itemPayment.customer.email.toLowerCase().includes(item) ||
                        itemPayment.customer.phone.toLowerCase().replace(/\s/g, '').includes(item) ||
                        itemPayment.customer.addressCity.toLowerCase().includes(item) ||
                        itemPayment.customer.addressZipcode.toLowerCase().includes(item)
                    )
                })
                return item
            })
            props.setResults(resultsFormat)
        } else {
            props.setResults(props.data)
        }

    }

    return (

        <InputGroup>
            <InputGroup.Text className={['inputSearchIcon', props.theme === 'light' ? 'inputSearchIconLight' : 'inputSearchIconDark'].join(" ")}>
                {props.icon ? props.icon : <FontAwesomeIcon icon={faMagnifyingGlass} />}
            </InputGroup.Text>
            <Form.Control
                ref={inputSearchRef}
                value={props.search}
                type={'text'}
                placeholder={props.placeholder}
                className={['inputSearch', props.theme === 'light' ? 'inputSearchLight' : 'inputSearchDark'].join(" ")}
                onChange={(e) => onChange(e.target.value)}
                onKeyPress={(event) => props.onPressEnter && event.key === "Enter" ? props.onPressEnter() : null}
            />
        </InputGroup>

    )

})

export default InputSearch
